// @core/api/endpoints/calendar/propose_new_time.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProposeNewTimeRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Propose new time
 * Allows an attendee to propose an alternative time for the event. The organizer is notified and can accept or reject the proposal.
 */
export async function ProposeNewTime(
  event_id: string,
  data: ProposeNewTimeRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/events/:event_id/propose-time`;
  requestPath = requestPath.replace(':event_id', encodeURIComponent(event_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
